// settings-service.js
import { postData } from "./http-service";
import { baseUrl } from "../environments/environment";
import { getToken } from "./token-manager";
// settings-service.js

export const getAllSettings = async () => {
  const res = await fetch(`${baseUrl}/api/settings`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json"
      // no Authorization header
    },
  });

  if (!res.ok) {
    console.error("Failed to load settings:", res.statusText);
    return null;
  }

  return res.json();
};

export const updateHeaderSettings = async (headerDto) => {
  const res = await postData({
    path: "settings/update-header",
    data: headerDto,
    toasterMessage: "Header settings updated!",
  });
  if (!res.ok) throw new Error("Failed to save header settings");
  return; // no need to parse JSON if your controller returns no body
};


export const updateSettings = async (settingsBody) => {
  const response = await postData({
    path: "settings/update",
    data: settingsBody,
    toasterMessage: "Settings Successfully Updated!",
  });
  if (!response.ok) {
    throw new Error("Could not update settings");
  }
  return response.json();
};

export const uploadLogo = async (file) => {
  const formData = new FormData();
  formData.append("logo", file);

  const token = await getToken();
  if (!token && tokenNeeded) {
    window.location.reload();
    return;
  }

  // Build your fetch init object
  const init = {
    method: "POST",
    headers: {},
    body: formData,
  };

  // Only set Authorization if we have a token
  if (token) {
    init.headers["Authorization"] = `Bearer ${token}`;
  }

  const res = await fetch(`${baseUrl}/api/settings/upload-logo`, init);

  

  if (!res.ok) {
    const text = await res.text();
    throw new Error(`Logo upload failed: ${res.status} ${text}`);
  }

  return res.json();
};
